module.exports = __webpack_public_path__ + "static/media/home-header.50d97272.svg";